import { useMemo } from 'react';

import { Criterion } from '@cast/shared-search-ui';
import { PVFilterValueEntry } from '@cast/types-stop';

export const pvNamesCriterion: Criterion<PVFilterValueEntry[]> = {
  key: 'pvNames',
};

export const statusCriterion: Criterion<'failure' | 'success'> = {
  key: 'status',
};

const ENABLED_METRICS_CRITERIA: Criterion<boolean>[] = [
  { key: 'sizeDecreased', initialValue: false },
  { key: 'iopsDecreased', initialValue: true },
  {
    key: 'throughputDecreased',
    initialValue: true,
  },
  { key: 'sizeIncreased', initialValue: true },
  { key: 'iopsIncreased', initialValue: true },
  { key: 'throughputIncreased', initialValue: true },
];

export const usePvEventsCriteria = (): Criterion[] =>
  useMemo(
    () => [...ENABLED_METRICS_CRITERIA, pvNamesCriterion, statusCriterion],
    []
  );
